import { TRACKING_EVENT_NAMES } from './constants'

/**
 * Merges is_ai_notetaker_enabled into BOOKING_PAGE_SHARED properties
 * when the value is defined. For use in plain functions that cannot call hooks.
 *
 * @param {Object} properties - The event properties
 * @param {boolean | null} isAiNotetakerEnabled - The notetaker enabled state
 * @returns {Object} Properties with is_ai_notetaker_enabled conditionally included
 */
export const buildBookingPageSharedProperties = (properties, isAiNotetakerEnabled) => ({
  ...properties,
  ...(isAiNotetakerEnabled != null && {
    is_ai_notetaker_enabled: isAiNotetakerEnabled
  })
})

/**
 * Plain-function counterpart to useTrackBookingPageShared.
 * Fires a BOOKING_PAGE_SHARED event for call sites that cannot use hooks.
 *
 * @param {Function} track - The track function (e.g. from Segment)
 * @param {Object} properties - The event properties
 * @param {boolean | null} isAiNotetakerEnabled - The notetaker enabled state
 * @param {{ version?: number }} [options]
 */
export const fireBookingPageShared = (track, properties, isAiNotetakerEnabled, { version = 2 } = {}) => {
  track({
    name: TRACKING_EVENT_NAMES.BOOKING_PAGE_SHARED,
    version,
    properties: buildBookingPageSharedProperties(properties, isAiNotetakerEnabled)
  })
}
